import { general } from './general';
import { datecontrol } from './datecontrol';

export const daterange = (data = {}) => general('daterange', {
  to: datecontrol((data || {}).to),
  from: datecontrol((data || {}).from),
  present: (data || {}).present,
});
